/***
 * This function needed for check is value null or undefined
 * at all project
 */

export const isTruthy = (value: any): boolean => {
  if (value === null || value === undefined) {
    return false
  } else {
    return true
  }
}
